module.exports = __webpack_public_path__ + "static/media/construccion.6c4c14f0.jpg";